export default function digestMiddleware($rootScope, $timeout) {
    return store => next => action => {
		$timeout(() => {
      		next(action);
    	});
  	};
}